import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export async function listarTestemunhosPublicos() {
  const res = await fetch(`${API_URL}/testemunhos/publico`);
  if (!res.ok) throw new Error('Erro ao buscar testemunhos');
  return res.json();
}

export async function listarTestemunhosAdmin() {
  const res = await fetch(`${API_URL}/testemunhos`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!res.ok) throw new Error('Erro ao listar testemunhos');
  return res.json();
}

export async function criarTestemunho(data) {
  const res = await fetch(`${API_URL}/testemunhos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(data)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao criar testemunho');
  return body;
}

export async function atualizarTestemunho(id, data) {
  const res = await fetch(`${API_URL}/testemunhos/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(data)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao atualizar testemunho');
  return body;
}

export async function eliminarTestemunho(id) {
  const res = await fetch(`${API_URL}/testemunhos/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao eliminar testemunho');
  return body;
}
